import React, { useEffect, useRef, useState } from "react";

// styles imports
import './ProgressBar.scss';

export const Comment = `
	/**
	 *
	 * props の定義
	 *
	 * [set]
	 * 		id				...	スタイルシートid指定の文字列
	 * 		class			...	スタイルシートクラス指定の文字列
	 *
	 * [act]
	 * 		onclick			...	クリック時に実行したい処理
	 */
	`

const ProgressBar = (props) => {
	const [currentMainProgress, setCurrentMainProgress] = useState(0);
	const [currentSubProgress, setCurrentSubProgress] = useState(0);

	// 初回表示時と値の変更時にアニメーションを適用
	useEffect(() => {
		const timeout = setTimeout(() => {
		const percentage = Math.min(Math.max(props.progress * 100, 0), 100); // 0%～100%に制限
		const subPercentage = Math.min(Math.max(props.subProgress * 100, 0), 100); // 0%～100%に制限
		setCurrentMainProgress(percentage);
		setCurrentSubProgress(subPercentage);
	  }, 100); // 初回表示時のアニメーション遅延

	  return () => clearTimeout(timeout); // クリーンアップ
	}, [props.progress, props.subProgress]);

	return (
		<div
			className="progress-bar"
			style={{
				"--main-progress": `${currentMainProgress}%`, // プログレスバーの幅
				"--sub-progress": `${currentSubProgress}%`, // プログレスバーの幅
			}}
		>
			<div
				className="progress"
			></div>
			<div
				className="sub-progress"
			></div>
		</div>
	);
};

export default ProgressBar;